import { Link } from "react-router-dom";
function Contacts() {
  return (
    <div className="container">
      <div className="contactsBlock">
        <div className="contact-item">
          <h3>Телефон</h3>
          <a className="contact-link" href="tel:+74992800001">
            +7 (499) 280-00-01
          </a>
          <h3>Почта</h3>
          <a className="contact-link" href="mailto:info@aitiguru.ru">
            info@aitiguru.ru
          </a>
          <h3>Адрес</h3>
          <p>
            108802, г. Москва, вн.тер.г. поселение Сосенское, д. Сосенки, ул.
            Ясеневая, д. 3, эт/пом/ком 1/1/11
          </p>
        </div>
        <div className="contact-item">
          <h3>Юридическая информация</h3>
          <p>
            <b>Полное наименование: </b>
            Общество с ограниченной ответственностью "АйтиГуру"
          </p>
          <p>
            <b>Сокращенное наименование: </b>
            ООО «АЙТИ ГУРУ» Юридический адрес: 108802, г. Москва, вн.тер.г.
            поселение Сосенское, д. Сосенки, ул. Ясеневая, д. 3, эт/пом/ком
            1/1/11
          </p>
          <p>
            <b>ИНН: </b>
            7751196430
          </p>
          <p>
            <b>КПП: </b>775101001
          </p>
          <p>
            <b>ОГРН: </b>1217700190950
          </p>
        </div>
        <div className="contact-item">
          <form action="">
            <h3>Форма обратной связи</h3>
            <fieldset>
              <input type="text" placeholder="Ваше имя" value="" />
              <input type="text" placeholder="Почта" value="" />
              <textarea name="" id="" placeholder="Ваше сообщение"></textarea>
            </fieldset>
            <fieldset>
              <div className="form-group">
                <input type="checkbox" name="" id="checkPolicy" />
                <label for="checkPolicy">
                  Я прочитал <Link to="/soglashenie">условия соглашения</Link> и
                  согласен с{" "}
                  <Link to="/politica">Политикой конфиденциальности</Link>
                </label>
              </div>
            </fieldset>
            <button type="submit">Отправить</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contacts;
